<template lang="pug">
    v-chart(:option="chartDataAllocationCount" autoresize :class="className")
</template>

<script>
export default {

    props: {
        allocationMetrics: { type: Object, required: true },
        hasAccountAccessToKibanaStats: { type: Boolean, required: false },
        className: { type: String, required: false, default: '' },
        allocationSelected: { type: Boolean, required: false},
        affectationSelected: { type: Boolean, required: false}
    },

    computed: {
        wrapperClass() {
            return this.className + '-wrapper'
        },
        chartDataAllocationCount() {
            const hasAccountAccessToKibanaStats = this.hasAccountAccessToKibanaStats
            return {
                color: ['#796BF4', '#0090FF'],
                legend: {
                    show: false,
                    left: 'center',
                    top: '0',
                    textStyle: {
                        fontSize: 14,
                        color: '#809FB8',
                        fontWeight: 'bold'
                    },
                    selected: {
                        'Allocation': this.allocationSelected,
                        'Affectation': hasAccountAccessToKibanaStats ? this.affectationSelected : false
                    },
                    data: hasAccountAccessToKibanaStats ? ['Allocation', 'Affectation'] : ['Allocation']
                },
                height: '80%',
                xAxis: {
                    axisLine: {
                        lineStyle: {
                            color: '#809FB8'
                        },
                        textStyle: {
                            color: 'red'
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            color: 'transparent'
                        },
                    },
                    alignTicks: true,

                    nameLocation: 'center',
                    verticalAlign: 'middle',
                    align: 'center',
                    nameGap: 50,
                    type: 'category',
                    boundaryGap: false,
                    data: Object.keys(this.allocationMetrics.allocationByDate),
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgb(217, 225, 231)',
                            opacity: 0.6
                        }
                        
                    }
                },
                grid: {
                    left: '5%',
                    bottom: '10%',
                    right: '5%',
                    top: '10%'
                },
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: (num) => Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'K' : Math.sign(num)*Math.abs(num)
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#809FB8'
                            }
                        },
                        nameTextStyle: {
                            color: '#809FB8'
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#809FB8'
                            }
                        },
                        splitLine: {
                            show: false
                        },
                        nameGap: 15
                    },
                    ...this.kibanaYAxis
                ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        label: {
                            show: true
                        }
                    }
                },
                series: [
                    {
                        type: 'line',
                        name: 'Allocation',
                        symbolSize: 5,
                        data: Object.values(this.allocationMetrics.allocationByDate),
                        sampling: 'average',
                        smooth: true,
                        areaStyle: {
                            color: '#895BF1',
                            opacity: 0.8
                        },
                        symbol: 'none',
                        lineStyle: {
                            width: 0
                        }
                    },
                    ...this.kibanaSeries
                ]
            }
        },
        kibanaSeries() {
            if (!this.hasAccountAccessToKibanaStats) return []
            return [
                {
                    colorBy: 'series',
                    type: 'line',
                    name: 'Affectation',
                    data: Object.values(this.allocationMetrics.kibanaAllocation),
                    sampling: 'average',
                    yAxisIndex: 1,
                    smooth: true,
                    symbol: 'none',
                    areaStyle: {},
                    itemStyle: {
                        color: '#0090FF',
                    },
                    lineStyle: {
                        color: '#809FB8',
                        width: 0
                    },
                }
            ]
        },
        kibanaYAxis() {
            if (!this.hasAccountAccessToKibanaStats) return []

            return [
                {
                    type: 'value',
                    yAxisIndex: 1,
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        formatter: (num) => Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'K' : Math.sign(num)*Math.abs(num)
                    },
                    showGrid: false,
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: '#809FB8'
                        }
                    },
                    nameGap: 15
                }
            ]
        }
    }
}
</script>
